import * as Sentry from "@sentry/react";
import { type RegisteredRouter } from "@tanstack/react-router";

export function initSentry(router: RegisteredRouter) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_URL,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.tanstackRouterBrowserTracingIntegration(router),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", import.meta.env.VITE_API_URL],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  });
}
